module.exports = [{"uppercase":" A ","lowcase":" a "},{"uppercase":" E ","lowcase":" e "},{"uppercase":" I ","lowcase":" i "},{"uppercase":" O ","lowcase":" o "},{"uppercase":" U ","lowcase":" u "},{"uppercase":" Em ","lowcase":" em "},{"uppercase":" No ","lowcase":" no "},{"uppercase":" Na ","lowcase":" na "},{"uppercase":" De ","lowcase":" de "},{"uppercase":" Do ","lowcase":" do "},{"uppercase":" Da ","lowcase":" da "},{"uppercase":" Di ","lowcase":" di "},{"uppercase":" Du ","lowcase":" du "}]


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/helpers/preposicoes.json
// module id = 1155
// module chunks = 0